import axios from 'axios';
import _ from './lodash';
import globals from '../globals/communityGlobals';

const errorMessages = globals.getArea('error');

axios.defaults.withCredentials = 'true';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store';
axios.defaults.headers.common.Pragma = 'no-cache';

const requestInProgress = [];
const excludeEndpoints = ['get_v1/query/GetSettings'];
const createUniqueKey = (method, baseUrl, uri) => {
  const requestUrl = uri.slice(0, uri.indexOf('?'));
  const hasBaseUrl = requestUrl.startsWith(baseUrl);
  const filteredUrl = hasBaseUrl ? requestUrl.slice(baseUrl.length + 1, requestUrl.length) : requestUrl;

  return `${method}_${filteredUrl}`;
};

axios.interceptors.request.use(
  config => {
    const requestKey = createUniqueKey(config.method, config.baseURL, config.url);
    if (excludeEndpoints.includes(requestKey)) return config;

    const duplicateRequest = _.find(requestInProgress, { key: requestKey });
    const cancelToken = axios.CancelToken.source();

    config.cancelToken = cancelToken.token;

    if (duplicateRequest && config.method.toLowerCase() === 'get') {
      duplicateRequest.request.cancel(errorMessages.getMsg('cancelDuplicateRequest'));
      _.remove(requestInProgress, { key: requestKey });
    }

    requestInProgress.push({ key: requestKey, request: cancelToken });

    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  response => {
    const requestKey = createUniqueKey(response.config.method, response.config.baseURL, response.config.url);
    _.remove(requestInProgress, { key: requestKey });

    return response;
  },
  error => {
    return Promise.reject(error);
  },
);

export default axios;
